import React from 'react';
import './style.scss';

interface Props {
    percent: number;
    isBelow?: boolean;
    className?: string;
}

const CircularProgress = ({ percent, isBelow, className }: Props) => {
    const ROTATE_VALUE = 360;

    const calculateRotation = (): number => {
        return ROTATE_VALUE * (percent / 100);
    };

    return (
        <div className={`progress-circle ${percent > 50 ? 'over50' : ''} ${isBelow ? 'below' : ''} ${className} `}>
            <span>{Math.floor(percent)}%</span>
            <div className="left-half-clipper">
                <div className="first50-bar"></div>
                <div className="value-bar" style={{ transform: `rotate(${calculateRotation()}deg)` }}></div>
            </div>
        </div>
    );
};

export default CircularProgress;
